<h6 class="bxt-table-title">
    {{ title() }}
</h6>
<span class="action-divider"></span>
<div class="email-list-action-bar">
    <a
        id="btnRefreshEmailList"
        name="btnRefreshEmailList"
        class="refresh-email-list-button"
        [class.loading]="isLoading()"
        [throttleTime]="750"
        (appSingleClick)="!isLoading() && refreshEmailList()">
        <i class="fa-solid fa-rotate-right"></i> {{ isLoading() ? 'Loading...' : 'Refresh' }}
    </a>
</div>

<bx-table-header
    [showCreateNew]="showCreateNew() && (newEmailPermission() === undefined || permissionService.isAvailable(newEmailPermission()!))"
    [createNewEnabled]="createNewEnabled()"
    (createNew)="createNewEmail()"
    [searchable]="showSearch()"
    (searchEvent)="setSearch($event)"
    [showSettingsActions]="false">
</bx-table-header>

<div class="table-wrapper">
    <ngx-datatable
        #emailListTable
        *ngIf="isLoaded()"
        class="material bxt-table"
        [rowHeight]="rowHeight"
        [rows]="rows()"
        [columnMode]="'force'"
        [headerHeight]="headerHeight"
        [loadingIndicator]="isLoading()"
        [scrollbarV]="true"
        [selectionType]="selectionType.checkbox"
        [selected]="selectedRows()"
        (select)="onSelect($event)"
        [scrollbarH]="layoutService.isMobile()"
        [externalSorting]="true"
        [virtualization]="false"
        [sorts]="[{ prop: 'date', dir: 'desc' }]"
        (scroll)="onScroll($event)"
        (resize)="onResize($event)">
        <!-- columns -->

        @if (canDeleteEmails) {
            <ngx-datatable-column
                [width]="30"
                [sortable]="false"
                [canAutoResize]="false"
                [draggable]="false"
                [resizeable]="false"
                [headerCheckboxable]="true"
                [checkboxable]="true"></ngx-datatable-column>
        }

        <ngx-datatable-column name="Sent" prop="date" [sortable]="false" [width]="emailListWidths.date">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span>{{ row.date | date: 'mediumDate' }}</span
                >&nbsp;<span>{{ row.date | date: 'shortTime' }}</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Sent By" prop="stringified.from" [sortable]="false" [width]="emailListWidths.sentBy">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.stringified && spaceDelimiter(row.stringified.from) }}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Recipients" prop="stringified.to" [sortable]="false" [width]="emailListWidths.to">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.stringified && spaceDelimiter(row.stringified.to) }}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
            name="Subject"
            prop="subject"
            [sortable]="false"
            [cellClass]="'show-pipe clickable-column'"
            [headerClass]="'show-pipe'"
            [width]="emailListWidths.subject">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <a class="bxt-row-action" (click)="viewEmail(row)">{{ row.subject }}</a>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Status" prop="hasError" [sortable]="false" [width]="emailListWidths.status">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <app-email-tracking-status [observeTrackingStatusChangedEvents]="false" [email]="row"></app-email-tracking-status>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
            [width]="100"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
            [cellClass]="'right-align'"
            [headerClass]="'disabled'">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="button-container">
                    @if (canDeleteEmails) {
                        <button type="button" class="btn btn-sm btn-danger" (click)="deleteEmail(row)" title="Delete">
                            <i class="ti-trash"></i>
                        </button>
                    }
                    <button type="button" class="btn btn-sm btn-default" (click)="resendEmail(row)" title="Resend/Forward">
                        <i class="ti-share"></i>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>

@if (canDeleteEmails && selectedRows().length) {
    <app-bx-sticky-action-bar [multiSelectActionCount]="selectedRows().length" (cancelClicked)="clearSelectedRows()">
        <ng-container sticky-bar-desktop-actions>
            <button
                type="button"
                id="btnDeleteEmail"
                (click)="deleteSelectedEmails()"
                class="btn-bx-secondary-stroked ml-1"
                data-pendo-tagging="Email Delete Desktop">
                Delete ({{ selectedRows().length }})
            </button>
        </ng-container>
        <ng-container sticky-bar-mobile-actions>
            <mat-nav-list>
                <mat-list-item (click)="deleteSelectedEmails()" data-pendo-tagging="Email Delete Mobile">
                    <span mat-line>Delete ({{ selectedRows().length }})</span>
                </mat-list-item>
            </mat-nav-list>
        </ng-container>
    </app-bx-sticky-action-bar>
}
